import { login, logout, getInfo, formLogin } from '@/api/mobile/user'
import { getToken, setToken, removeToken, setMobileSchoold } from '@/utils/auth'

const getDefaultState = () => {
  return {
    mobileToken: getToken(),
    mobileName: '',
    mobileAvatar: ''
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.mobileToken = token
  },
  SET_NAME: (state, name) => {
    state.mobileName = name
  },
  SET_AVATAR: (state, avatar) => {
    state.mobileAvatar = avatar
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        const { name, avatar } = data
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        setToken(data.token)
        setMobileSchoold(data.school_id)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  formLogin({ commit }, userInfo) {
    const { username, password, openid, school_id } = userInfo
    return new Promise((resolve, reject) => {
      formLogin({ username: username.trim(), password: password, openid: openid, school_id: school_id }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        const { name, avatar } = data
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        setToken(data.token)
        setMobileSchoold(data.school_id)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      const userToken = state.mobileToken ? state.mobileToken : getToken()
      getInfo(userToken).then(response => {
        const { data } = response
        if (!data) {
          reject('Verification failed, please Login again.')
        }
        const { name, avatar } = data
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        removeToken() // must remove token first
        commit('RESET_STATE')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove token first
      commit('RESET_STATE')
      resolve()
    })
  },
  setLogin({ commit }, userInfo) {
    const { name, avatar, token } = userInfo
    commit('SET_TOKEN', token)
    setToken(token)
    commit('SET_NAME', name)
    commit('SET_AVATAR', avatar)
  },
  setToken({ commit }, token) {
    commit('SET_TOKEN', token)
    setToken(token)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/mobile.js